import React from "react";
import { cn } from "./cn";

type Size = "sm" | "md" | "lg";
type Tone = "brand" | "neutral";

type Props = React.HTMLAttributes<HTMLSpanElement> & {
  firstName?: string | null;
  lastName?: string | null;
  size?: Size;
  tone?: Tone;
};

const sizes: Record<Size, string> = {
  sm: "h-7 w-7 text-[10px]",
  md: "h-9 w-9 text-[11px]",
  lg: "h-12 w-12 text-[13px]",
};

const tones: Record<Tone, string> = {
  brand: "bg-brand text-white",
  neutral: "bg-gray-100 text-gray-700 ring-1 ring-inset ring-gray-200",
};

const initialsOf = (first?: string | null, last?: string | null) => {
  const f = first?.trim()?.[0] ?? "";
  const l = last?.trim()?.[0] ?? "";
  return (f + l).toUpperCase() || "•";
};

const Avatar: React.FC<Props> = ({
  firstName,
  lastName,
  size = "md",
  tone = "brand",
  className,
  ...rest
}) => (
  <span
    aria-hidden
    className={cn(
      "inline-flex shrink-0 select-none items-center justify-center rounded-full font-semibold tracking-wide",
      sizes[size],
      tones[tone],
      className,
    )}
    {...rest}
  >
    {initialsOf(firstName, lastName)}
  </span>
);

export default Avatar;
